import { Divider, Stack } from '@mui/material';

import { api } from 'common';

import { ASYNCHRONOUS_JOB_VARIANTS } from './Variants';
import { FeatureFlagKey, useFlag } from '../../../../../../../utils/flags';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { BlockSwitchField } from '../../ConfigFields/Switch';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

import DurationUnits = api.FlowDefinition.DurationUnits;

export function AsynchronousJobFormFields() {
  const { value: jobKind } =
    useSelectedNodeField<api.FlowDefinition.AsynchronousExportJobBlock['config']['jobKind']>(
      'config.jobKind'
    );
  const { Config } = (jobKind ? ASYNCHRONOUS_JOB_VARIANTS[jobKind] : null) ?? {
    Config: null,
  };
  const canConfigureSignalV2 = useFlag({
    flagKey: FeatureFlagKey.canConfigureSignalV2,
  });
  return (
    <Stack spacing={2}>
      <BlockSelectField
        fieldName="config.jobKind"
        label="Job Kind"
        required
        options={Object.keys(ASYNCHRONOUS_JOB_VARIANTS).map((value) => ({
          label: value,
          value,
          disabled:
            // TODO: Remove EXPORT_AUTHORIZATION_STATUS v1 once we migrate last customer to V2
            // https://app.notablehealth.com/staff/app#/agents/flows?agentId=0194af13-e0d8-70ee-ac40-1c94f830f5c2
            // https://app.asana.com/1/1187495389489253/project/1209560168696100/task/1210968725002731?focus=true
            value === 'EXPORT_AUTHORIZATION_STATUS',
        }))}
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[DurationUnits.Hours, DurationUnits.Minutes, DurationUnits.Seconds]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
      />
      {canConfigureSignalV2 && <BlockSwitchField fieldName="config.v2" label="Signal v2" />}
      {Config && (
        <>
          <Divider />
          <Config />
        </>
      )}
    </Stack>
  );
}
